import CustomButton from "components/Atoms/CustomButton"
import CustomDialog from "components/Atoms/CustomDialog"
import StringInput from "components/Atoms/StringInput"
import DynamicSelector from "components/Molecules/DynamicSelector"
import FileUpload from "components/Molecules/FileUpload"
import FormController from "components/Molecules/FormController"
import {
  TransactionStatus,
  useCreateAccountTransactionMutation,
} from "generated/graphql"
import {
  ALL_PAYMENT_METHODS,
  ALL_TRANSACTION_TYPES,
} from "graphql/selector.queries.gql"
import { cloneDeep, set } from "lodash-es"
import React, { useState } from "react"
import { useSearchParams } from "react-router-dom"
import AppToaster from "utils/AppToaster"
import clsx from "utils/clsx"
import { inr } from "utils/formatters.utils"
type AddAccountTransactionType = {}
const AddAccountTransaction = ({}: AddAccountTransactionType) => {
  const [params, setParams] = useSearchParams()
  const [state, setState] = useState<any>({})
  const account = parseInt(params.get("account"))
  const codename = params.get("codename")
  const balance = parseFloat(params.get("balance"))

  const [create, { loading }] = useCreateAccountTransactionMutation({
    onCompleted({
      newAccountTransaction: {
        accountTransaction: { account },
      },
    }) {
      AppToaster.show({
        icon: "endorsed",
        message: `Transaction added successfully. new balance is ${inr(
          account.balance
        )}`,
        intent: "success",
      })
      setState({})
      params.delete("account")
      params.delete("codename")
      params.delete("balance")
      setParams(params)
    },
  })
  return (
    <CustomDialog
      width={"40%"}
      isOpen={account ? true : false}
      onClose={() => {
        params.delete("account")
        params.delete("codename")
        params.delete("balance")
        setParams(params)
      }}
      light
      icon="th-list"
      title={`Account - ${codename}`}
      footerRightButton={
        <CustomButton
          onClick={() => {
            if (state?.amount < 0) {
              return AppToaster.show({
                icon: "cross",
                message: `Amount cannot be negative`,
                intent: "danger",
              })
            }
            create({
              variables: {
                accountId: account.toString(),
                amount: state?.amount,
                status: TransactionStatus.SUC,
                remark: state?.remark,
                transactionTypeId: state?.transactionType?.id,
                paymentMethodId: state?.paymentMethod?.id,
                attachment: state?.attachment
                  ? {
                      url: state?.attachment,
                      mediaType: "photo",
                    }
                  : null,
              },
            })
          }}
          loading={loading}
          dark
          text={"Transaction"}
          icon="confirm"
        />
      }
    >
      <div className="mb-3">
        <h1>
          Current Balance -{" "}
          <span
            className={clsx(
              balance >= 0 ? "text-green" : "text-red",
              "font-500"
            )}
          >
            {inr(balance)}
          </span>
        </h1>
      </div>
      <div className="grid gap-x-4 grid-cols-3">
        <FormController
          source={state}
          onChange={(path, value) => {
            const stateCopy = cloneDeep(state)
            set(stateCopy, path, value)
            setState(stateCopy)
          }}
        >
          <StringInput
            min={0}
            type="number"
            placeholder="Amount"
            label="Amount"
            path="amount"
            required
            big={false}
          />
          <DynamicSelector
            query={ALL_TRANSACTION_TYPES}
            required
            path="transactionType"
            label="Transaction Type"
          />
          <DynamicSelector
            query={ALL_PAYMENT_METHODS}
            required
            path="paymentMethod"
            label="Payment Method"
          />
          <StringInput label="Reference ID" path="referenceId" big={false} />
          <FileUpload label="Photo" path="attachment" />
          <StringInput big={false} label="Remark" path="remark" />
        </FormController>
      </div>
    </CustomDialog>
  )
}

export default AddAccountTransaction
